import Vue from 'vue';
import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm';
import { ValidationObserver } from 'vee-validate';

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
